import React, { useState } from 'react';
import { Form, Input, Button, message, Card, Modal, Typography, Alert } from 'antd';
import { login, adminRequestTemporaryPassword, adminChangePassword } from '../services/api';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [forgotOpen, setForgotOpen] = useState(false);
  const [mustChangeOpen, setMustChangeOpen] = useState(false);
  const [temporaryPassword, setTemporaryPassword] = useState('');
  const [forgotForm] = Form.useForm();
  const [changeForm] = Form.useForm();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const data = await login(values);
      if (data?.mustChangePassword) {
        setTemporaryPassword(values.password);
        changeForm.setFieldsValue({ currentPassword: values.password });
        setMustChangeOpen(true);
        message.warning('当前登录的是临时密码，请先修改密码。');
      } else {
        window.location.href = '/dashboard';
      }
    } catch (error) {
      message.error(error.response?.data?.message || error.message || '登录失败');
    } finally {
      setLoading(false);
    }
  };

  const handleForgotPassword = async (values) => {
    setLoading(true);
    try {
      const res = await adminRequestTemporaryPassword(values.email);
      message.success(res?.message || '如果管理员账号存在，临时密码邮件已发送。');
      setForgotOpen(false);
      forgotForm.resetFields();
    } catch (error) {
      message.error(error.response?.data?.message || error.message || '发送临时密码失败');
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async (values) => {
    setLoading(true);
    try {
      await adminChangePassword({
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
      });
      setMustChangeOpen(false);
      changeForm.resetFields();
      setTemporaryPassword('');
      message.success('密码修改成功，正在进入后台。');
      window.location.href = '/dashboard';
    } catch (error) {
      message.error(error.response?.data?.message || error.message || '修改密码失败');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24 }}>
      <Card title="管理员登录" style={{ width: '100%', maxWidth: 380 }}>
        <Form onFinish={onFinish} layout="vertical">
          <Form.Item name="username" label="用户名" rules={[{ required: true, message: '请输入用户名' }]}>
            <Input placeholder="输入管理员用户名" />
          </Form.Item>
          <Form.Item name="password" label="密码" rules={[{ required: true, message: '请输入密码' }]}>
            <Input.Password placeholder="输入密码" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            登录
          </Button>
        </Form>

        <div style={{ marginTop: 16, textAlign: 'right' }}>
          <Typography.Link onClick={() => setForgotOpen(true)}>忘记密码</Typography.Link>
        </div>
      </Card>

      <Modal
        title="找回管理员密码"
        open={forgotOpen}
        footer={null}
        onCancel={() => setForgotOpen(false)}
        destroyOnClose
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 16 }}
          message="系统会向管理员邮箱发送临时密码，收到后请使用临时密码登录，并立即修改为正式密码。"
        />
        <Form form={forgotForm} layout="vertical" onFinish={handleForgotPassword}>
          <Form.Item
            name="email"
            label="管理员邮箱"
            rules={[
              { required: true, message: '请输入管理员邮箱' },
              { type: 'email', message: '请输入正确的邮箱格式' },
            ]}
          >
            <Input placeholder="输入管理员邮箱" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            发送临时密码
          </Button>
        </Form>
      </Modal>

      <Modal
        title="临时密码首次登录"
        open={mustChangeOpen}
        footer={null}
        closable={false}
        maskClosable={false}
      >
        <Alert
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
          message="当前登录的是临时密码。必须先修改为正式密码，才能进入后台。"
        />
        <Form form={changeForm} layout="vertical" onFinish={handleChangePassword}>
          <Form.Item
            name="currentPassword"
            label="当前密码"
            initialValue={temporaryPassword}
            rules={[{ required: true, message: '请输入当前密码' }]}
          >
            <Input.Password placeholder="输入当前临时密码" />
          </Form.Item>
          <Form.Item
            name="newPassword"
            label="新密码"
            rules={[
              { required: true, message: '请输入新密码' },
              { min: 6, message: '新密码至少 6 位' },
            ]}
          >
            <Input.Password placeholder="输入新密码" />
          </Form.Item>
          <Form.Item
            name="confirmPassword"
            label="确认新密码"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: '请再次输入新密码' },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('newPassword') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error('两次输入的新密码不一致'));
                },
              }),
            ]}
          >
            <Input.Password placeholder="再次输入新密码" />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={loading} block>
            修改密码并进入后台
          </Button>
        </Form>
      </Modal>
    </div>
  );
};

export default Login;
